/**
 * `/logs/alarms` — Alarms log page (M3 Phase A — placeholder).
 *
 * Surfaces low-reservoir + future alarm events. For M3.A this is a
 * placeholder that explains the route exists; the underlying WS
 * `lowReservoir` stream + persistent storage of acknowledged alarms
 * will be wired up after the rule-engine v2 milestone lands.
 *
 * The persistent banner above the page (`<LowReservoirBanner>`) already
 * shows *current* alarms — this page is meant to be the *history* view.
 */
import { Card, CardBody, CardHeader, CardTitle } from '../components/Card';

export function LogsAlarmsPage() {
  return (
    <div className="min-h-screen px-6 py-8" data-testid="logs-alarms-page">
      <header className="mb-6">
        <h1 className="text-xl font-semibold tracking-tight text-reef-100">
          Alarms
        </h1>
        <p className="text-sm text-reef-400 mt-1">
          History of triggered alarms across all sources.
        </p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>Coming soon</CardTitle>
        </CardHeader>
        <CardBody>
          <p className="text-sm text-reef-300">
            Persistent alarm history will land alongside the Rules v2
            milestone. In the meantime, live low-reservoir alerts appear
            in the orange banner at the top of every page, and the
            Control Log records every safety-related write.
          </p>
        </CardBody>
      </Card>
    </div>
  );
}